export enum ActivityRenderHintType {
    Embedded = 'EMBEDDED',
    Modal = 'MODAL'
}
